import { useState } from "react";
import api from "../api/api";

type Step = "email" | "otp" | "changePassword";

const ForgotPassword: React.FC = () => {
  const [step, setStep] = useState<Step>("email");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");

  const sendOtp = async () => {
    try {
      const res = await api.post("/auth/forgot-password", { email });
      setMessage(res.data.message);
      setStep("otp");
    } catch (err: any) {
      setMessage(err.response?.data?.detail || "Error sending OTP");
    }
  };

  const verifyOtp = async () => {
    try {
      const res = await api.post("/auth/verify-otp", { email, otp });
      setMessage(res.data.message);
      setStep("changePassword");
    } catch (err: any) {
      setMessage(err.response?.data?.detail || "Invalid OTP");
    }
  };

  const changePassword = async () => {
    try {
      const res = await api.post("/auth/change-password", { email, otp, new_password: newPassword });
      setMessage(res.data.message);
      setStep("email"); // Redirect to login
    } catch (err: any) {
      setMessage(err.response?.data?.detail || "Error updating password");
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 p-6 border rounded shadow">
      <h2 className="text-xl font-bold mb-4">Forgot Password</h2>
      {message && <p className="mb-4 text-green-600">{message}</p>}

      {step === "email" && (
        <>
          <input
            type="email"
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-2 border rounded mb-4"
          />
          <button onClick={sendOtp} className="w-full p-2 bg-blue-600 text-white rounded">
            Send OTP
          </button>
        </>
      )}

      {step === "otp" && (
        <>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="w-full p-2 border rounded mb-4"
          />
          <button onClick={verifyOtp} className="w-full p-2 bg-blue-600 text-white rounded">
            Verify OTP
          </button>
        </>
      )}

      {step === "changePassword" && (
        <>
          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="w-full p-2 border rounded mb-4"
          />
          <button onClick={changePassword} className="w-full p-2 bg-green-600 text-white rounded">
            Change Password
          </button>
        </>
      )}
    </div>
  );
}
export default ForgotPassword;